import React, { PureComponent } from 'react';
import {
  LogoutOutlined,
  QuestionCircleOutlined,
  SettingOutlined,
  SyncOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { Badge, Menu, message, Spin, Tooltip } from 'antd';
import { formatMessage, FormattedMessage } from 'umi-plugin-react/locale';
import router from 'umi/router';
import HeaderDropdown from '../HeaderDropdown';
import NoticeIcon from '../NoticeIcon';
import SelectOrganisation from '../SelectOrganisation';
import styles from './index.less';
import { connect } from 'dva';
import MultiAccountSelector from '../PageHeaderWrapper/MultiAccountSelector';
import { userCan } from '@/utils/authority';
import { SCAN_STATUS } from '@/utils/constant';

@connect(({ notifications, user, cloudAccount, reports, organisation }) => ({
  notifications: notifications.list,
  user: user.currentUser,
  allCloudAccountsList: cloudAccount.allCloudAccountsList,
  selectedCloudAccounts: cloudAccount.selectedCloudAccounts,
  reports,
  organisation: organisation.current,
  packageExpiry: organisation.packageExpiry,
}))
export default class GlobalHeaderRight extends PureComponent {
  state = {
    unseenCount: 0,
    riskCount: 0,
    systemCount: 0,
  };

  componentDidMount() {
    if (this.props.organisation) {
      this.getBillngInfo();
    }
  }
  componentDidUpdate(prevProps, prevState) {
    // console.log('CDU of Global Header', { prevProps, prevState });

    if (
      JSON.stringify(prevProps.user.alertsCount) !== JSON.stringify(this.props.user.alertsCount) ||
      prevProps?.organisation?.id !== this.props?.organisation?.id
    ) {
      const { user, organisation } = this.props;

      if (organisation?.id && user && user.hasOwnProperty('alertsCount')) {
        let riskCount = user?.alertsCount[organisation?.id]?.risks || 0;
        // var systemCount = user.alertsCount.systems;
        let systemCount = user?.alertsCount[organisation.id]?.systems
          ? user.alertsCount[organisation.id].systems
          : 0;
        let unseenCount = riskCount + systemCount;
        this.setState({
          unseenCount,
          riskCount,
          systemCount,
        });
      }
    }
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.getBillngInfo();
    }
    if (prevProps.organisation !== this.props.organisation) {
      this.getBillngInfo();
    }
  }
  getBillngInfo() {
    const { dispatch, organisation } = this.props;
    if (organisation && organisation.id) {
      dispatch({
        type: 'organisation/current',
        payload: {
          params: {
            id: organisation.id,
          },
        },
      });
    }
  }
  getNoticeData() {
    let notices = this.sortNotifications();
    if (notices === null || notices.length === 0) {
      return {};
    }
    const transformedNotices = notices.reduce((object, noticeSet) => {
      const noticeSetType = noticeSet.type;
      return {
        ...object,
        [noticeSetType]: [...noticeSet.unseen, ...noticeSet.seen],
      };
    }, {});

    const readyForUI = Object.keys(transformedNotices).reduce((acc, key) => {
      const readyForUINotices = transformedNotices[key].map(notice => {
        const newNotice = { ...notice };

        newNotice.key = newNotice.id;
        if (key === 'risk') {
        } else if (key === 'info') {
        }

        return newNotice;
      });

      return { ...acc, [key]: readyForUINotices };
    }, {});

    return readyForUI;
  }

  getUnreadData = noticeData => {
    const unreadMsg = {};
    Object.entries(noticeData).forEach(([key, value]) => {
      if (!unreadMsg[key]) {
        unreadMsg[key] = 0;
      }
      if (Array.isArray(value)) {
        unreadMsg[key] = value.filter(item => !item.read).length;
      }
    });
    return unreadMsg;
  };

  getResourceData = (params, drawerType, signatureData) => {
    //
    if (!signatureData.hasOwnProperty('risk')) {
      router.push(signatureData.url);
      const { dispatch } = this.props;
      dispatch({
        type: 'user/addInviteDescription',
        payload: {
          description: signatureData.description,
          createdAt: signatureData.createdAt,
        },
      });
    } else {
      const { organisation, dispatch } = this.props;
      dispatch({
        type: 'universalDrawer/save',
        payload: {
          alertCloudAcc: [signatureData?.risk?.cloudAccount?.id],
          notificationResourcesData: signatureData,
        },
      });
      dispatch({
        type: 'resourcesReport/getReport',
        payload: {
          orgId: organisation.id,
          cloudAccounts: [signatureData?.risk?.cloudAccount?.id],
        },
      });

      // dispatch getFilteredResources here
      dispatch({
        type: 'universalDrawer/getResourcesOfSingleRisk',
      });
      const { type, value } = params;

      let extraObj = [
        {
          type: type,
          value,
        },
      ];
      extraObj.push({
        type: 'cloudAccounts',
        value: [signatureData?.risk?.cloudAccount?.id],
      });
      extraObj = JSON.stringify(extraObj);
      let urlQuery = `?org=${organisation.id}&filters=${extraObj}&dType=${drawerType}`;

      router.push(urlQuery);
    }
  };
  sortNotifications() {
    let { notifications } = this.props;

    let infoSeen = [];
    let infoUnseen = [];
    let riskSeen = [];
    let riskUnseen = [];

    if (Array.isArray(notifications)) {
      notifications.map(v => {
        if (v.type === 'info') {
          if (v.state === 'seen') {
            infoSeen.push(v);
          } else if (v.state === 'unseen') {
            infoUnseen.push(v);
          }
        }
        if (v.type === 'risk') {
          if (v.state === 'seen') {
            riskSeen.push(v);
          } else if (v.state === 'unseen') {
            riskUnseen.push(v);
          }
        }
      });
    }

    let infoObj = {
      type: 'info',
      seen: infoSeen,
      unseen: infoUnseen,
    };

    let riskObj = {
      type: 'risk',
      seen: riskSeen,
      unseen: riskUnseen,
    };
    let fnfArr = [infoObj, riskObj];

    return fnfArr;
  }
  render() {
    const {
      currentUser,
      fetchingNotices,
      onNoticeVisibleChange,
      onMenuClick,
      onNoticeClear,
      theme,
      isMobile,
      user,
      packageExpiry,
      organisation,
      allCloudAccountsList,
    } = this.props;
    const { unseenCount, riskCount, systemCount } = this.state;
    let packageType = '';
    if (organisation && organisation.package) {
      packageType = organisation && organisation.package.type;
    }

    const currentlyScanningCloudAccounts = allCloudAccountsList.filter(
      account =>
        account.status === SCAN_STATUS.RUNNING.status ||
        (account.XRayScan?.status && account.XRayScan.status === SCAN_STATUS.RUNNING.status)
    );
    const currentlyScanningCloudAccountsCount = currentlyScanningCloudAccounts.length;

    const menu = (
      <Menu className={styles.menu} selectedKeys={[]} onClick={onMenuClick}>
        <Menu.Item key="userinfo">
          <SettingOutlined />
          <FormattedMessage id="menu.account.settings" defaultMessage="account settings" />
        </Menu.Item>
        {/* {userCan('update-profile') && (
        )} */}
        {userCan('update-profile') && <Menu.Divider />}
        <Menu.Item key="logout">
          <LogoutOutlined />
          <FormattedMessage id="menu.account.logout" defaultMessage="logout" />
        </Menu.Item>
      </Menu>
    );
    const noticeData = this.getNoticeData();
    //

    let className = styles.right;
    if (theme === 'dark') {
      className = `${styles.right}  ${styles.dark}`;
    }
    const text = <span>Get help</span>;
    return (
      <div style={{ display: 'inline-flex' }} className={className}>
        {currentlyScanningCloudAccountsCount && currentlyScanningCloudAccountsCount > 0 ? (
          <div
            style={{
              opacity: '0.5',
              marginTop: '4px',
              display: 'flex',
              gap: '0.5rem',
              alignItems: 'center',
              marginRight: '20px',
            }}
          >
            <Tooltip title="Open the Cloud Account Selector to view scan progress">
              Scanning {currentlyScanningCloudAccountsCount} account
              {currentlyScanningCloudAccountsCount > 1 ? 's' : ''}
              &nbsp;
              <SyncOutlined spin />
            </Tooltip>
          </div>
        ) : (
          ''
        )}
        <MultiAccountSelector msg="" />
        <SelectOrganisation className={styles.action} isMobile={isMobile} />

        <span style={{ marginLeft: 10, marginRight: 5 }}>
          <Tooltip title={text}>
            <a
              target="_blank"
              href="https://cloudnosys.com/docs"
              rel="noopener noreferrer"
              className={styles.action}
            >
              <QuestionCircleOutlined
                style={{ color: '#595959', position: 'relative', top: 3, fontSize: 18 }}
              />
            </a>
          </Tooltip>

          <Tooltip title="Notifications">
            <NoticeIcon
              className={styles.action}
              count={this.state.unseenCount && this.state.unseenCount}
              onItemClick={(item, tabProps) => {
                //

                let extraFilteration = {
                  type: 'signatureName',
                  value: [item && item.risk && item.risk.signature],
                };

                this.getResourceData(extraFilteration, 'signatureDrawer', item);
                if (item.link) router.push(item.link);
              }}
              loading={fetchingNotices}
              locale={{
                emptyText: formatMessage({ id: 'component.noticeIcon.empty' }),
                clear: formatMessage({ id: 'component.noticeIcon.clear' }),
                viewMore: formatMessage({ id: 'component.noticeIcon.view-more' }),
                notification: formatMessage({ id: 'component.globalHeader.notification' }),
                message: formatMessage({ id: 'component.globalHeader.message' }),
                event: formatMessage({ id: 'component.globalHeader.event' }),
              }}
              onClear={onNoticeClear}
              onPopupVisibleChange={onNoticeVisibleChange}
              onViewMore={() => message.info('Click on view more')}
              clearClose
            >
              <NoticeIcon.Tab
                unseen={
                  Object.keys(noticeData).length > 0
                    ? noticeData.risk.filter(notice => notice.state === 'unseen')
                    : []
                }
                list={Object.keys(noticeData).length > 0 ? noticeData.risk : []}
                title={
                  <Badge
                    count={riskCount && riskCount}
                    style={{ background: '#F0F2F5', color: 'black', marginTop: '7px' }}
                  >
                    <span style={{ marginLeft: '15px', marginRight: '19px' }}>Risks</span>
                  </Badge>
                }
                emptyText={this.props.notifications === null ? <Spin /> : <p>No Risks</p>}
                // showViewMore
              />
              <NoticeIcon.Tab
                unseen={
                  Object.keys(noticeData).length > 0
                    ? noticeData.info.filter(notice => notice.state === 'unseen')
                    : []
                }
                list={Object.keys(noticeData).length > 0 ? noticeData.info : []}
                title={
                  <Badge
                    count={systemCount && systemCount}
                    style={{ background: '#F0F2F5', color: 'black', marginTop: '7px' }}
                  >
                    <span style={{ marginLeft: '15px', marginRight: '19px' }}>System</span>
                  </Badge>
                }
                emptyText={this.props.notifications === null ? <Spin /> : <p>No Information</p>}
                // showViewMore
              />
            </NoticeIcon>
          </Tooltip>

          <Tooltip title="">
            {currentUser ? (
              <Badge
                count={
                  currentUser.isVerified === false && packageExpiry === 'remaining'
                    ? 'Not Verified'
                    : currentUser.isVerified === true &&
                      packageExpiry === 'remaining' &&
                      packageType === 'trial'
                    ? 'Trial'
                    : currentUser.isVerified === true && packageExpiry === 'expired'
                    ? 'Expired'
                    : ''
                }
                style={{
                  backgroundColor:
                    currentUser.isVerified === true && packageExpiry === 'remaining'
                      ? '#FA9850'
                      : 'red',
                  marginLeft: '-6px',
                  marginTop: '-1px',
                  zIndex: '-9',
                }}
              />
            ) : (
              <Spin size="small" style={{ marginLeft: 8, marginRight: 8 }} />
            )}
          </Tooltip>
          <Tooltip title="User">
            {currentUser.email ? (
              <HeaderDropdown overlay={menu}>
                <span className={`${styles.action} ${styles.account}`}>
                  <UserOutlined
                    style={{ marginRight: 8, position: 'relative', top: 3, fontSize: 20 }}
                  />

                  <span className={styles.name}>{currentUser.email}</span>
                </span>
              </HeaderDropdown>
            ) : (
              <Spin size="small" style={{ marginLeft: 8, marginRight: 8 }} />
            )}
          </Tooltip>
        </span>
      </div>
    );
  }
}
